<template>
<div :class="step === 0 ? 'preview-container with-thing' : 'preview-container'">
<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 485 134">
  <g class="previewer">
      <rect width="485" height="134" x="0" y="0" style="fill:rgb(255,255,255);" />

      <rect width="230" height="20" x="160" y="18" :class="[1, 3, 4, 5].indexOf(step) !== -1 ? 'active' : null" :style="custom_color && [1,3,4,5].indexOf(step) !== -1 ? 'fill:' + custom_color : ''" />
      <circle cy="67" cx="69" r="52" :class="step === 1 ? 'active' : null" :style="custom_color && step === 1 ? 'fill:' + custom_color : ''" />

      <g class="description" :class="step === 2 ? 'active' : null" :style="custom_color && step === 2 ? 'fill:' + custom_color : ''">
          <rect width="267" height="7" x="160" y="48"  />
          <rect width="240" height="7" x="160" y="58"  />
          <rect width="250" height="7" x="160" y="68"  />
      </g>

      <g>
          <rect width="44" height="8" x="160" y="111"  />
          <rect width="77" height="8" x="210" y="111"  />
          <rect width="30" height="8" x="293" y="111"  />
      </g>

      <rect width="105" height="29" x="373" y="97" :class="step === 3 ? 'active': null" :style="custom_color && step > 2 ? 'fill:' + custom_color : ''" />
  </g>
</svg>
</div>
</template>

<script>

export default {
  name: 'preview',
  props: ['step', 'custom_color'],
  data () {
    return {
    }
  }
}
</script>

<style scoped>

.previewer>g,
.previewer>rect,
.previewer>circle
{
    fill: #B7BABD;
    transition: fill .5s ease;
}

.previewer>g.active,
.previewer>rect.active,
.previewer>circle.active
{
    fill: #94719C;
    fill: #35bacf;
}

.preview-container.with-thing {
    background: url(/assets/img/onboarding-start.png);
    padding: 100px 50px;
    max-width: 375px;
    background-size: contain;
    background-position: center;
    background-repeat: no-repeat;
    margin: 0 auto;
}

@media (max-width: 800px) {
    .preview-container.with-thing {
        padding: 70px 50px;
        margin-bottom: -56px;
        max-width: 300px;
    }
}
</style>



// WEBPACK FOOTER //
// Preview.vue?6c7c2caf